(function(){
  function prep(v){
    if (!v || v._vmReady) return;
    var src = v.getAttribute('data-src');
    var source = v.querySelector('source');
    if (src && !v.getAttribute('src')) {
      v.setAttribute('src', src);
      if (source && source.getAttribute('data-src')) source.setAttribute('src', source.getAttribute('data-src'));
      v.load();
    }
    v._vmReady = true;
  }
  function centerIndex(rail){
    var cards = [].slice.call(rail.querySelectorAll('[data-vm-iv-card]'));
    if (!cards.length) return 0;
    var mid = rail.scrollLeft + rail.clientWidth / 2;
    var best = 0, bestDist = Infinity;
    cards.forEach(function(c,i){
      var cx = c.offsetLeft + c.offsetWidth / 2;
      var d = Math.abs(cx - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }
  function updateFocus(rail){
    var cards = [].slice.call(rail.querySelectorAll('[data-vm-iv-card]'));
    var idx = centerIndex(rail);
    cards.forEach(function(c,i){
      c.classList.toggle('is-center', i === idx);
      var v = c.querySelector('video');
      if (!v) return;
      prep(v);
      if (i === idx && rail.getAttribute('data-autoplay-mute') === 'true') {
        v.muted = true;
        var p = v.play(); if (p && p.catch) p.catch(function(){});
      } else {
        v.pause();
      }
    });
  }
  function scrollToIndex(rail, idx){
    var cards = rail.querySelectorAll('[data-vm-iv-card]');
    var c = cards[idx]; if (!c) return;
    var left = c.offsetLeft - (rail.clientWidth - c.offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }
  function boot(root){
    var rail = root.querySelector('[data-vm-iv-rail]'); if (!rail) return;
    var prev = root.querySelector('[data-vm-iv-prev]');
    var next = root.querySelector('[data-vm-iv-next]');
    var ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ updateFocus(rail); ticking = false; });
    }
    rail.addEventListener('scroll', onScroll, { passive: true });
    if (prev) prev.addEventListener('click', function(){ scrollToIndex(rail, Math.max(0, centerIndex(rail)-1)); });
    if (next) next.addEventListener('click', function(){
      var cards = rail.querySelectorAll('[data-vm-iv-card]');
      scrollToIndex(rail, Math.min(cards.length-1, centerIndex(rail)+1));
    });
    root.querySelectorAll('[data-vm-iv-play]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var card = btn.closest('[data-vm-iv-card]');
        var v = card && card.querySelector('video');
        if (!v) return;
        prep(v);
        if (v.paused) { v.muted = false; v.play().catch(function(){}); }
        else v.pause();
      });
    });
    // initial center on middle card
    var cards = rail.querySelectorAll('[data-vm-iv-card]');
    if (cards.length) {
      scrollToIndex(rail, Math.min(1, cards.length-1));
      setTimeout(function(){ updateFocus(rail); }, 350);
    }
  }
  function init(){ document.querySelectorAll('[data-vm-iv]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector && e.target.querySelector('[data-vm-iv]');
    if (root) boot(root);
    else if (e.target.matches && e.target.matches('[data-vm-iv]')) boot(e.target);
  });
})();
